import SidebarLayout from "./SidebarLayout";
import React, { useState, useEffect } from 'react';
import { Typography, Button, Row, Col, List, Input, Spin, message } from 'antd';
import { useHistory } from "react-router-dom";
import { routes } from '../../routes/Routes';
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import _BankerService from '../../modules/BankerService';
import { COMMON_ERROR_MSG } from '../../constants/constants';
import "../FirmAdmin/FirmAdminDashboard.scss";

const { Text } = Typography;
const PAGE_SIZE = 10;

// Firms tab (Senior Private Banker): lists only firms this banker created (Sponser.BankerId ==
// their own id), unlike the Compliance Admin/Underwriter Banker Firms tab which is assignment-based
// (SponserUsers). Same list UI/flow as FirmDashboardForComplianceAdmin.js, kept as a separate
// component rather than sharing it, since the two are backed by different data-scoping rules.
const FirmDashboardForSeniorBanker = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [firmData, setFirmData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const userId = localStorage.getItem("BankerId");

    useEffect(() => {
        if (userId) {
            getFirmsList();
        }
    }, [userId]);

    const getFirmsList = async () => {
        try {
            setLoading(true);
            const res = await _BankerService.getFirmsListForSeniorPrivateBanker(userId);
            if (res.data.IsSuccess) {
                setFirmData(res.data.Obj || []);
            } else {
                setFirmData([]);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const onViewDetailsClick = (item) => {
        if (item.FirmId) {
            history.push({
                pathname: routes.seniorBankerFacilityDetails.path,
                state: { firmId: item.FirmId, companyName: item.CompanyName },
            });
            return;
        }
        history.push({
            pathname: routes.complianceAdminSponserDetails.path,
            state: { sponserId: item.SponserId },
        });
    };

    const handleSearchChange = (value) => {
        setSearchText(value);
        setCurrentPage(1);
    };

    const handleReset = () => {
        setSearchText("");
        setCurrentPage(1);
    };

    const filteredFirms = firmData.filter((item) =>
        (item?.CompanyName || "").toLowerCase().includes(searchText.trim().toLowerCase())
    );

    return (
        <Spin spinning={loading}>
            <SidebarLayout>
                <div className="firm-admin-dashboard">

                    <h4 level={3} className="title">
                        Firms
                        <div><text className="dashboard-subtitle">Select a firm to view its facilities.</text></div>
                    </h4>

                    <Row justify="space-between" align="middle" className="firms-list-toolbar" style={{ marginBottom: 16 }}>
                        <Col flex="auto" style={{ maxWidth: 320 }}>
                            <Input
                                value={searchText}
                                onChange={(e) => handleSearchChange(e.target.value)}
                                placeholder="Search Firm Name"
                                prefix={<SearchOutlined />}
                                allowClear
                                className="firm-search-input"
                            />
                        </Col>
                        <Col>
                            <Button onClick={handleReset}>
                                Reset
                            </Button>
                        </Col>
                    </Row>

                    <List
                        className="firms-list card-section"
                        itemLayout="horizontal"
                        dataSource={filteredFirms}
                        locale={{ emptyText: loading ? " " : "No Credit Facilities Assigned Yet" }}
                        pagination={{
                            current: currentPage,
                            pageSize: PAGE_SIZE,
                            onChange: setCurrentPage,
                            showSizeChanger: false,
                            className: "pagination",
                        }}
                        renderItem={(item, index) => (
                            <List.Item
                                key={item.FirmId || item.SponserId || index}
                                actions={[
                                    <Button
                                        type="link"
                                        className="app-view-Btn"
                                        onClick={() => onViewDetailsClick(item)}
                                    >
                                        View Details <RightOutlined />
                                    </Button>,
                                ]}
                            >
                                <List.Item.Meta title={<Text className="company-name">{item?.CompanyName}</Text>} />
                            </List.Item>
                        )}
                    />

                </div>
            </SidebarLayout>
        </Spin>
    );
};

export default FirmDashboardForSeniorBanker;
